<template>
	<div class="main architecture">
		<!-- <div class="title">
			产品案例
		</div> -->
		<!-- <div class="info">
			Brain<sup>++</sup>提供的能力覆盖算法、算力、数据的全流程，加速开发流程，提升优化和部署效率
		</div> -->
		<div class="model">
			<ul class="tab">
				<li :class="{'li-active':angle==index*90}" @click="rotate(item)" v-for="(item,index) in menu"
					:key="'li'+index">
					{{item}}
				</li>
			</ul>
			<div class="content">
				<div class="circle"><img src="../assets/vue-turntable/1.png" alt="" class="circle-bg"
						:class="'angle-'+angle">
					<div class="border-bg">
						<img src="../assets/vue-turntable/球1.svg" alt="" class="circle-center"
							:style="{'opacity':ball_interval.index===1?'1':'0'}">
						<img src="../assets/vue-turntable/球2.svg" alt="" class="circle-center"
							:style="{'opacity':ball_interval.index===2?'1':'0'}">
						<img src="../assets/vue-turntable/球3.svg" alt="" class="circle-center"
							:style="{'opacity':ball_interval.index===3?'1':'0'}">
					</div>
					<img src="../assets/vue-turntable/2.png" alt="" class="right">
					<span class="text" :class="'text-'+(index+1)" @click="rotate(item)" :key="'span'+index"
						v-for="(item,index) in turntableMenu()">
						{{item}}
					</span>
				</div>
				<div class="MegEngine-text">
					<el-button class="direction" icon="el-icon-arrow-left" circle style=" left: 100px; top: 100px;"
						:disabled="text_index===1" @click="text_index--"></el-button>
					<el-button class="direction" icon="el-icon-arrow-right" circle style=" right: 50px; top: 100px;"
						:disabled="text_index+2>=text[angle/90].length" @click="text_index++"></el-button>
					<vue-virtual :list="text[angle/90].slice(text_index-1,text_index+2)" :more="false"></vue-virtual>
					<!-- <img src="../assets/vue-turntable/2fd2ebc.svg" alt=""> -->
				</div>
			</div>
		</div>
		<router-link to="/home/product/all" class="" style="text-decoration: none;color: #0166FF;"><button
				class="index-btn">更&nbsp;多&nbsp;产&nbsp;品</button></router-link>
	</div>
</template>

<script>
	import vueVirtual from '@/components/vue-virtual'

	import {
		mapState,
		mapMutations
	} from 'vuex'
	export default {
		components: {
			vueVirtual
		},
		data() {
			return {
				angle: 0,
				menu: ['医药', '护理', '工科', '其他'],
				text: [
					[{
							id: '97473E03-563D-4AAD-87DE-DFF0C96F0121',
							title: '药房管理虚拟实训系统  ',
							img: 'http://yigee.cn:81//Files/img/1.png',
							label1: '易格',
							label2: '北京易格通智仿真',
							url: 'http://yigee.cn:81//Files/ProductContent/1.html'
						},
						{
							id: 'F94E60CA-1FDE-4F85-8AD4-260863A356B4',
							title: '药品分析仪器虚拟仿真教学系统',
							img: 'http://yigee.cn:81//Files/ProductContent/listimages/f94e60ca-1fde-4f85-8ad4-260863a356b4.png',
							label1: '易格',
							label2: '北京易格通智仿真',
							url: 'http://yigee.cn:81//Files/ProductContent/f94e60ca-1fde-4f85-8ad4-260863a356b4.html'
						},
						{
							id: '5387544C-47A0-48EA-A364-E3B0CA67EF38',
							title: '中药鉴别实训仿真软件',
							img: 'http://yigee.cn:81//Files/img/5.png',
							label1: '易格',
							label2: '北京易格通智仿真',
							url: 'http://yigee.cn:81//Files/ProductContent/5.html'
						}, {
							id: 'EF63758A-8DEF-4CAF-BCAC-FABC6972B418',
							title: 'GSP药品经营质量管理规范模拟教学软件',
							img: 'http://yigee.cn:81//Files/img/8.png',
							label1: '易格',
							label2: '北京易格通智仿真',
							url: 'http://yigee.cn:81//Files/ProductContent/8.html'
						}
					],
					[{
							id: '0B4EDF5A-0E7E-4A33-9FF1-0C6902F240A7',
							title: '护理技术模拟教学系统',
							img: 'http://yigee.cn:81//Files/img/10.png',
							label1: '易格',
							label2: '北京易格通智仿真',
							url: 'http://yigee.cn:81//Files/ProductContent/10.html'
						},
						{
							id: '9235691B-2A5B-4501-AAB2-7CBF7744172F',
							title: '护理临床思维培训及测评软件  ',
							img: 'http://yigee.cn:81//Files/img/9.png',
							label1: '易格',
							label2: '北京易格通智仿真',
							url: 'http://yigee.cn:81//Files/ProductContent/9.html'
						}
					],
					[{
							id: '54384EFA-9C95-4C72-9476-437B7BFADBE7',
							title: '焊接技术应用仿真实训软件',
							img: 'http://yigee.cn:81//images/gk2.png',
							label1: '易格',
							label2: '北京易格通智仿真',
							url: 'http://yigee.cn:81//Files/ProductContent/b706e30d-e30f-4856-9e5e-aec9952f7573.html'
						},
						{
							id: '21E33021-B461-46C8-8A96-AB7D57AAAB93',
							title: '建筑施工技术仿真实训软件',
							img: 'http://yigee.cn:81//images/4543.png',
							label1: '易格',
							label2: '北京易格通智仿真',
							url: 'http://yigee.cn:81//Files/ProductContent/fe5e552c-0a41-4a0d-8613-b875e5c61052.html'
						},
						{
							id: '81F3B707-2432-44FB-9101-52D0EC1AFF56',
							title: '电工电子技术仿真软件',
							img: 'http://yigee.cn:81//images/gk1.png',
							label1: '易格',
							label2: '北京易格通智仿真',
							url: 'http://yigee.cn:81//Files/ProductContent/d7347418-8a81-475d-bb89-d3fb5824fcca.html'
						},
						{
							id: '6E2B1CD7-8E4B-4646-8966-3AFF681B7B82',
							title: '模具拆装实训平台',
							img: 'http://yigee.cn:81//images/gk4.png',
							label1: '易格',
							label2: '北京易格通智仿真',
							url: 'http://yigee.cn:81//Files/ProductContent/c6707669-6261-4c61-b922-b0281cf4ad25.html'
						}
					],
					[{
						id: 'A195120E-DFE1-4FD9-AE9F-211F5D643A80',
						title: '中药种植栽培3D虚拟仿真实训平台',
						img: 'http://yigee.cn:81//Files/img/6.png',
						label1: '易格',
						label2: '北京易格通智仿真',
						url: 'http://yigee.cn:81//Files/ProductContent/6.html'
					}, {
						id: 'FFE2CE9B-4615-4F17-AE42-AA2A3D52EA9F',
						title: '中药数字博物馆',
						img: 'http://yigee.cn:81//Files/img/4.png',
						label1: '易格',
						label2: '北京易格通智仿真',
						url: 'http://yigee.cn:81//Files/ProductContent/4.html'
					}, {
						id: 'B279B146-756B-4303-AE46-09A88D522FF7',
						title: '仿真实训软件（信阳毛尖）',
						img: 'http://yigee.cn:81//Files/ProductContent/listimages/b279b146-756b-4303-ae46-09a88d522ff7.png',
						label1: '易格',
						label2: '北京易格通智仿真',
						url: 'http://yigee.cn:81//Files/ProductContent/b279b146-756b-4303-ae46-09a88d522ff7.html'
					}, {
						id: '8B2223E2-A060-4F60-8049-37D4453A5FA0',
						title: 'AR易课程平台-中药材(20)',
						img: 'http://yigee.cn:81//Files/ProductContent/listimages/8b2223e2-a060-4f60-8049-37d4453a5fa0.png',
						label1: '易格',
						label2: '北京易格通智仿真',
						url: 'http://yigee.cn:81//Files/ProductContent/8b2223e2-a060-4f60-8049-37d4453a5fa0.html'
					}]
				],
				text_index: 1,
				ball_interval: {
					index: 1
				}
			}
		},
		methods: {
			rotate(title) {
				this.angle = this.menu.indexOf(title) * 90
				this.text_index = 1
			},
			turntableMenu() {
				let newMenu = [...this.menu]
				newMenu.splice(0, this.angle / 90).forEach(item => {
					newMenu.push(item)
				})

				return newMenu
			},
			ball() {
				setInterval(() => {
					if (++this.ball_interval.index >= 3) {
						this.ball_interval.index = 1
					}
				}, 5000)
			},
			...mapMutations(['setProducts']),
			async Product() {
				const res = await this.$http.get('product/GetProduct.do')
				this.setProducts(res.data)
			}
		},
		mounted() {
			this.ball()
			this.Product()
		}
	}
</script>

<style scoped>
	.main {
		width: 1280px;
		margin: 0 auto;
		text-align: center;
	}

	.main .title {
		height: 150px;
		font-size: 30px;
		font-weight: 600;
		color: #00113a;
		line-height: 150px;
		text-align: center;
	}

	.main .info {
		height: 22px;
		font-size: 16px;
		font-weight: 500;
		color: #334161;
		line-height: 22px;
		margin-top: 16px;
	}

	.main .model {
		/* margin-top: 40px; */
	}

	.main .model .tab {
		list-style: none;
		padding: 0;
		margin: 0 auto;
		width: 420px;
		height: 38px;
		line-height: 38px;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: horizontal;
		-webkit-box-direction: normal;
		-webkit-flex-direction: row;
		-ms-flex-direction: row;
		flex-direction: row;
		-webkit-box-pack: justify;
		-webkit-justify-content: space-between;
		-ms-flex-pack: justify;
		justify-content: space-between;
	}

	.main .model .tab .li-active {
		/* color: #004ec4;
		 border-bottom: 2px solid #004ec4; */
		color: #007985;
		border-bottom: 2px solid #007985;
	}

	.main .model .tab li {
		width: 80px;
		font-size: 18px;
		font-weight: 600;
		color: #00113a;
		cursor: pointer;
	}

	.main .model .content {
		margin: 36px 0;
		height: 320px;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: horizontal;
		-webkit-box-direction: normal;
		-webkit-flex-direction: row;
		-ms-flex-direction: row;
		flex-direction: row;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
		width: 1280px;
	}

	.main .model .content .circle {
		height: 250px;
		width: 250px;
		z-index: 2;
		position: relative;
	}

	.main .model .content .circle .border-bg {
		width: 50%;
		height: 50%;
		position: absolute;
		left: 25%;
		top: 25%;
		box-sizing: border-box;
		padding: 5px;
		border-radius: 50%;
	/* 	background-image: -webkit-linear-gradient(left, #ffffff 0%, #9dc7eb 100%);
		background-image: -moz-linear-gradient(left, #ffffff 0%, #9dc7eb 100%);
		background-image: linear-gradient(left, #ffffff 0%, #9dc7eb 100%); */
	}

	.main .model .content .circle .circle-bg {
		width: 100%;
		-webkit-transition: all .5s;
		-o-transition: .5s all;
		transition: all .5s;
	}

	.main .model .content .circle .circle-center {
		transition: all .5s;
		width: 90%;
		height: 90%;
		position: absolute;
		left: 5%;
		top: 5%;
	}

	.main .model .content .circle .right {
		width: 86px;
		margin-top: 16px;
		position: absolute;
		right: -10px;
		top: 12px;
	}

	.main .model .content .circle .text {
		width: 200px;
		height: 100px;
		display: inline-block;
		position: absolute;
		font-size: 22px;
		color: #0c7dfe;
		line-height: 100px;
		cursor: pointer;
	}

	.main .model .content .circle .text-1 {
		left: 178px;
		cursor: default;
		width: 100px;
		height: 280px;
		line-height: 246px;
		color: #fff;
	}

	.main .model .content .circle .text-2 {
		left: 0;
		top: 0;
		line-height: 64px;
		margin-left: 24px;
	}

	.main .model .content .circle .text-3 {
		bottom: 5px;
		top: 0;
		left: 0;
		line-height: 253px;
		margin-left: 2px;
		height: 30px;
		width: 50px;
	}

	.main .model .content .circle .text-4 {
		left: 0;
		top: 185px;
		line-height: 64px;
		margin-left: 24px;
	}

	.main .model .content .MegEngine-text {
		position: relative;
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		-ms-flex: 1;
		flex: 1;
		width: 0;
		margin-left: -40px;
		background-image: url(https://assets.brainpp.com/brain/img/dcbdfda.svg);
		background-size: 63%;
		background-repeat: no-repeat;
		padding: 0 80px 11px 180px;
	}

	.main .model .content .MegEngine-text img {
		margin-top: 18px;
		cursor: pointer;
		transition: all .2s;
	}

	.main .model .content .MegEngine-text img:hover {
		transform: scale(2);
	}

	.main .model .content .MegEngine-text .direction {
		position: absolute;
		font-size: 24px;
	}

	.main .index-btn {
		width: 177px;
		height: 46px;
		background: rgba(1, 213, 119, 0);
		border: 1px solid #007985;
		font-size: 16px;
		font-weight: 700;
		color: #007985;
		line-height: 22px;
		cursor: pointer;
	}

	.angle-90 {
		transform: rotate(90deg);
		-ms-transform: rotate(90deg);
		/* IE 9 */
		-moz-transform: rotate(90deg);
		/* Firefox */
		-webkit-transform: rotate(90deg);
		/* Safari 和 Chrome */
		-o-transform: rotate(90deg);
		/* Opera */
	}

	.angle-180 {
		transform: rotate(180deg);
		-ms-transform: rotate(180deg);
		/* IE 9 */
		-moz-transform: rotate(180deg);
		/* Firefox */
		-webkit-transform: rotate(180deg);
		/* Safari 和 Chrome */
		-o-transform: rotate(180deg);
		/* Opera */
	}

	.angle-270 {
		transform: rotate(270deg);
		-ms-transform: rotate(270deg);
		/* IE 9 */
		-moz-transform: rotate(270deg);
		/* Firefox */
		-webkit-transform: rotate(270deg);
		/* Safari 和 Chrome */
		-o-transform: rotate(270deg);
		/* Opera */
	}
</style>
